module.exports = __webpack_public_path__ + "static/img/anB_4.64c88fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/anB_4.png
// module id = 1251
// module chunks = 1